export const PUBLIC_QUEST_TOTEM_HEADER = 'X-Quest-Totem-Unlock'

export const questTotemStorageKey = (eventSlug: string, questUid: string): string =>
  `gq:quest_totem:${eventSlug}:${questUid}`
